import {useAppContext} from "../../../../../contexts/AppContext";
import {useSearchParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {useEffect} from "react";
import {Card, Collapse, Grid, MenuItem, TextField} from "@mui/material";
import {TableFilterButtons} from "../../../../common/TableFilterButtons";

export function RetiradasManagementTableFilter({ isOpenFilters, isLoadingList, empresas, selectedIdEmpresa, setEmpresaAnterior }) {
    const { setEmpresaIdSession } = useAppContext();

    const [searchParams, setSearchParams] = useSearchParams()

    const id_empresa = searchParams.get('id_empresa');
    const matricula = searchParams.get('matricula');
    const cod_externo = searchParams.get('cod_externo');
    const tipo = searchParams.get('tipo');

    const { handleSubmit, reset, control, setValue } = useForm();

    useEffect(() => {
        reset({
            id_empresa: id_empresa ?? '',
            matricula: matricula ?? '',
            cod_externo: cod_externo ?? '',
            tipo: tipo ?? '',
        });
    }, [id_empresa, matricula, cod_externo, tipo, reset]);

    function handleSubmitFilter(data) {
        for (const key in data) {
            // remove campos vazios
            if (data[key] === '') {
                delete data[key];
            }
        }

        const queryFilters = {...data}

        // fill url params with filters
        setSearchParams(queryFilters);

        if (data.id_empresa) {
            setEmpresaIdSession(data.id_empresa);
        }
    }

    useEffect(() => {
        if (selectedIdEmpresa) {
            setValue('id_empresa', selectedIdEmpresa);
        }
    }, [selectedIdEmpresa, setValue]);

    return (
        <Grid item xs={12} component="form" onSubmit={handleSubmit(handleSubmitFilter)}>
            <Collapse in={isOpenFilters}>
                <Card variant="outlined" sx={{ padding: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="id_empresa"
                                control={control}
                                defaultValue={selectedIdEmpresa || ""}
                                render={({ field }) => {
                                    const { onChange, value, ...rest } = field;

                                    return (
                                        <TextField
                                            select
                                            label="Empresa"
                                            fullWidth
                                            size="small"
                                            value={value}
                                            onChange={(e) => {
                                                const novoValor = e.target.value;
                                                setEmpresaAnterior(value);

                                                onChange(novoValor);
                                            }}
                                            {...rest}
                                        >
                                            {empresas.length > 0 && empresas.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nomeFantasia}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    );
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="matricula"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        label="Matrícula do colaborador"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="cod_externo"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        label="Código externo do produto"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="tipo"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Tipo do registro"
                                        fullWidth
                                        size="small"
                                        select
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        <MenuItem value="retirada">Retirada</MenuItem>
                                        <MenuItem value="extra">Retirada Extra</MenuItem>
                                    </TextField>
                                )}
                            />
                        </Grid>

                        <TableFilterButtons
                            isLoading={isLoadingList}
                            handleClearFilters={() => {
                                setSearchParams((state) => {
                                    state.delete('matricula')
                                    state.delete('cod_externo')
                                    state.delete('tipo')
                                    // state.delete('id_empresa') // dont delete id_empresa, because it saved in session
                                    state.set('page', '1')

                                    return state
                                })

                                reset({
                                    matricula: matricula ?? '',
                                    cod_externo: cod_externo ?? '',
                                    id_empresa: id_empresa ?? '',
                                    tipo: tipo ?? '',
                                });
                            }}
                        />
                    </Grid>
                </Card>
            </Collapse>
        </Grid>
    );
}